import {Col, FormGroup, Label, Row} from "reactstrap";
import React, {Fragment} from "react";
import Select from "react-select";

export const ReturnsWarehouseAddress = (props) => {
    const {sellerState,errors,register,trigger,setValue,getValues}=props;
    return (
        <Fragment>
            <Row>
                <Col md={12}>
                    <FormGroup>
                        <Label className="form-label">First Line of Address</Label>
                        <input name="returnsFirstAddress" type="text" className={`form-control ${errors.returnsFirstAddress ? 'is-invalid' : ''}`} placeholder="107B Chadwell Heath Ln" {...register('returnsFirstAddress')}  />
                        <div className="invalid-feedback">{errors.returnsFirstAddress?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={12}>
                    <FormGroup>
                        <Label className="form-label">City</Label>
                        <input name="returnsCity" type="text" className={`form-control ${errors.returnsCity ? 'is-invalid' : ''}`} placeholder="Romford" {...register('returnsCity')}  />
                        <div className="invalid-feedback">{errors.returnsCity?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={12}>
                    <FormGroup>
                        <Label className="form-label">Country</Label>
                        <Select placeholder="United Kingdom" getOptionLabel ={(option)=>option.name} value={getValues('returnsCountry')}
                                getOptionValue ={(option)=>option.id} {...register("returnsCountry")} onChange={(e)=>{
                            setValue('returnsCountry',e);
                            trigger('returnsCountry');
                        }} className={` ${errors.returnsCountry ? 'is-invalid' : ''}`} options={sellerState.settings.countries} />
                        <div className="invalid-feedback">{errors.returnsCountry?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    );
};